import {Component, EventEmitter, forwardRef, HostListener, Input, OnChanges, Output, SimpleChanges, ViewChild, ViewEncapsulation} from '@angular/core';
import {AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, NgControl, ValidationErrors, Validator} from '@angular/forms';
import {PhoneNumberOptionModel} from './phone-number-option.model';
import {CountryCode} from 'libphonenumber-js';
import {IntlTelInputComponent} from './intl-tel-input/intl-tel-input.component';

@Component({
    selector: 'creditsnap-phone-number',
    templateUrl: './phone-number.component.html',
    styleUrls: ['./phone-number.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => PhoneNumberComponent),
        multi: true
    }, {
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => PhoneNumberComponent),
        multi: true
    }]
})
export class PhoneNumberComponent implements ControlValueAccessor, Validator, OnChanges {
    @ViewChild('phoneInput', {read: NgControl}) phoneElement: NgControl | undefined;
    @ViewChild(IntlTelInputComponent) intlTelInputCtrl: IntlTelInputComponent | undefined;

    @Input() id = 'mobile-number';
    @Input() label = 'Mobile number';
    @Input() prefilled: boolean = false;
    @Input() placeholder: string = 'Enter mobile number';
    @Input() options: PhoneNumberOptionModel = new PhoneNumberOptionModel();
    @Input('data-test-id') testId: string = 'phone-input';

    @Output() isValid: EventEmitter<boolean> = new EventEmitter<false>();
    @Output() phoneDataEvent: EventEmitter<any> = new EventEmitter();
    @Output() valueChange: EventEmitter<string> = new EventEmitter<string>();
    /**
     * Holds the current value of the slider
     */
    value: string;
    selectedCountry: CountryCode = 'US';

    ngOnChanges(changes: SimpleChanges) {
        if (changes.submitted && changes.submitted.currentValue && this.phoneElement) {
            this.phoneElement.control.markAsTouched();
        }
        if (changes.placeholder && changes.placeholder.currentValue) {
            this.options.inputPlaceholder = changes.placeholder.currentValue;
        } else if (changes.label && changes.label.currentValue) {
            this.options.inputPlaceholder = changes.label.currentValue;
        }

        if (changes.prefilled && changes.prefilled.currentValue) {
            this.prefilled = !!changes.prefilled.currentValue;
        }
        if (changes.id && changes.id.currentValue) {
            this.id = changes.id.currentValue;
        }
    }

    validate(control: AbstractControl): ValidationErrors | null {
        return this.phoneElement?.control.errors;
    }

    /**
     * Invoked when the model has been changed
     */
    onChange(_: string) {
        console.log(_);
    }

    /**
     * Invoked when the model has been touched
     */
    onTouched: () => void = () => {
    }

    /**
     * Method that is invoked on an update of a model.
     */
    updateChanges(value) {
        this.onChange(value);
    }

    ///////////////
    // OVERRIDES //
    ///////////////

    /**
     * Writes a new item to the element.
     * @param value the value
     */
    writeValue(value: string): void {
        this.value = value;
        setTimeout(() => {
            this.updateChanges(value);
        }, 50)


    }

    /**
     * Registers a callback function that should be called when the control's value changes in the UI.
     * @param fn
     */
    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    /**
     * Registers a callback function that should be called when the control receives a blur event.
     * @param fn
     */
    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }


    @HostListener('blur')
    @HostListener('focusout')
    @HostListener('input')
    handleClick() {
        this.handleValue();
    }

    private handleValue() {
        // if (this.intlTelInputCtrl.phoneNumber) {
        this.writeValue(this.intlTelInputCtrl.value);

        // }
    }

    touch() {
        this.phoneElement?.control.markAsTouched();
    }

    editPrefilledNumber() {
        this.prefilled = false;
        this.writeValue(null);
    }
}
